import React from 'react';
import { FOOTER_LINKS, SUPPORT_EMAIL } from '../data/config';
export function Footer() {
  return <footer className="bg-slate-950 px-4 py-5 text-center md:px-12" data-id="element-65" data-mp="3gfiugihumbe4">
      <p className="text-[11px] font-extrabold uppercase text-white" data-id="element-66" data-mp="32nulgo2wc31d">
        © 2026 Compra Digital Ya — Todos los derechos reservados.
      </p>
      <p className="mx-auto mt-1.5 max-w-[640px] text-[12px] leading-[1.4] text-white/70" data-id="element-67" data-mp="36q9354utwwr2">
        ATLAS MIOFASCIAL™ es un recurso educativo profesional. No sustituye la evaluación individualizada, el diagnóstico
        médico, el criterio clínico ni las guías profesionales vigentes. Los ejercicios y protocolos requieren revisión
        clínica especializada antes de utilizarse como referencia terapéutica.
      </p>
      <nav aria-label="Legal" className="mt-1.5 text-[12px] text-white" data-id="element-68" data-mp="3qblwzpgm4c1l">
        {FOOTER_LINKS.map((l, i) => <React.Fragment key={l.label} data-id="element-69" data-mp="2a19qldn7p8t2" data-mpi={i}>
            {i > 0 && <span className="mx-1.5" aria-hidden data-id="element-70" data-mp="2ezbbm4477i76">·</span>}
            <a href={l.href} className="transition-colors duration-150 hover:text-amber-400" data-id="element-71" data-mp="3l9k5dbpy7lcr">
              {l.label}
            </a>
          </React.Fragment>)}
      </nav>
      <p className="mt-1 text-[12px] text-white" data-id="element-72" data-mp="3gcjzp1x0gkm6">
        Soporte:{' '}
        <a href={`mailto:${SUPPORT_EMAIL}`} className="underline transition-colors duration-150 hover:text-amber-400" data-id="element-73" data-mp="3v8hpm2gccspy">
          {SUPPORT_EMAIL}
        </a>
      </p>
    </footer>;
}